export default "__VITE_ASSET__QbTBMoHn__"